import React from "react";
import { FormProvider } from "react-hook-form";
import { Create } from "@refinedev/mui";

import { LandingForm } from "@modules/landings/components/LandingForm";
import { useLandingCreateForm } from "./controller";

export const LandingCreate = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending } = useLandingCreateForm();

  return (
    <Create
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
    >
      <FormProvider {...methods}>
        <LandingForm />
      </FormProvider>
    </Create>
  );
});
